export default __webpack_public_path__ + "static/media/bookmarkActive.6c444e1c.svg";